<template>
  <div class="ingredient-color-box" :style="{ backgroundColor: `var(--u-color-${name})` }"></div>
</template>

<script>
export default {
  name: 'SerumIngredientColorBox',
  props: {
    name: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.ingredient-color-box {
  width: 20px;
  height: 20px;
  border-radius: 4px;
}
</style>
